import i18next from 'i18next';

i18next.addResources('es_CL', 'ModalCopiedCoupon', {
  title: '¡Código copiado!',
  description: 'Explora el catálogo, agrega productos a tu carrito y aplícalo en el checkout.',
  buttonText: 'Ir al menú'
});
